import { useState } from "react";

import { Grid, Typography, makeStyles, Box } from "@material-ui/core";

import { COLORS } from "../../../../theme/colors";
import { detailedAnalysisChartData } from "../../sample";
import { DetailedAnalysisTable } from "./detailedAnalysisTable";
import { bodyRows } from "../../../powerRevenues/tabs/detailedSensitivityAnalysis/sample";
import { PortfolioFinanceOutcomes } from "../sensitivityAnalysis/PortfolioFinanceOutcomes";
import { ActionButtonsGroup } from "../../../../components/buttonsGroup/ActionButtonsGroup";
import { SAHeaderBox } from "../../../powerRevenues/tabs/detailedSensitivityAnalysis/SAHeaderBox";

const initialFormData = {
  sold: {
    value: "5",
  },
  purchased: {
    value: "2.5",
  },
  praas: {
    value: "10",
  },
  gas: {
    value: "XXX",
  },
};

const useStyles = makeStyles((theme) => ({
  title: {
    margin: `${theme.spacing(3.5)}px 0 5px`,
  },
  titleUppercase: {
    textTransform: "uppercase",
    fontWeight: 700,
  },
  titleSpan: {
    textTransform: "initial",
    color: COLORS.darks[0][50],
    display: "flex",
    alignItems: "center",
    paddingLeft: 2,
  },
  star: {
    height: 25,
    fontSize: 24,
    color: COLORS.purple,
  },
  portfolioGrid: {
    backgroundColor: COLORS.white,
    borderRadius: "0 9px 9px 0",
    border: `1px solid ${COLORS.darks[0][10]}`,
    borderLeft: "none",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    overflow: "hidden",
  },
  portfolioBox: {
    padding: `${theme.spacing(3)}px ${theme.spacing(5.25)}px`,
  },
  portfolioFooterBox: {
    height: "57.5px",
    backgroundColor: "rgba(69, 148, 30, 0.5)",
  },
}));

export const DetailedAnalysis = () => {
  const classes = useStyles();
  const [formData, setFormData] = useState(initialFormData);
  const [tableData, setTableData] = useState(
    JSON.parse(JSON.stringify(bodyRows))
  );

  const handleChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: {
        value: value,
      },
    }));
  };

  const handleChangeTableData = (rowI, childRowI, key, value) => {
    const tempBodyRows = [...bodyRows];
    tempBodyRows[rowI]["childRows"][childRowI][key] = value;
    setTableData(tempBodyRows);
  };

  return (
    <Box>
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        className={classes.title}
      >
        <Box style={{ display: "flex", alignItems: "center" }}>
          <Typography className={classes.titleUppercase}>
            Detailed Analysis -
          </Typography>
          <Typography component="span" className={classes.titleSpan}>
            Fields marked with
            <Typography
              component="span"
              className={classes.star}
              style={{ padding: 2 }}
            >
              *
            </Typography>{" "}
            are editable
          </Typography>
        </Box>
        <Box
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography color="primary" style={{ marginRight: 20 }}>
            Proforma Cash Flow
          </Typography>
          <ActionButtonsGroup hideIntegrateBtn />
        </Box>
      </Grid>
      <SAHeaderBox
        title="Power parameters:"
        formData={formData}
        handleChange={handleChange}
      />
      <Grid container>
        <Grid item xs={3}>
          <DetailedAnalysisTable
            tableData={tableData}
            handleChangeTableData={handleChangeTableData}
          />
        </Grid>
        <Grid item xs={9} className={classes.portfolioGrid}>
          <Box className={classes.portfolioBox}>
            <PortfolioFinanceOutcomes data={detailedAnalysisChartData} />
          </Box>
          <Box className={classes.portfolioFooterBox}></Box>
        </Grid>
      </Grid>
      <Box style={{ padding: "20px 0" }}>
        <ActionButtonsGroup hideIntegrateBtn />
      </Box>
    </Box>
  );
};
